import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PURPLE, INK, FG_2, FG_3 } from './sections/theme.js';
import { ArrowIcon } from './sections/ArrowIcon.jsx';

const LANG_LOCALE = { en: 'en-US', es: 'es-AR', pt: 'pt-BR' };

export function BlogPostCard({ post, lang, titleComponent = 'h2', showDate = true }) {
    const { t } = useTranslation();
    return (
        <Stack
            component={Link}
            to={post.link}
            spacing={1.5}
            sx={{
                height: '100%',
                borderRadius: '16px',
                background: 'white',
                border: '1px solid rgba(81,36,166,0.1)',
                boxShadow: '0 8px 24px rgba(81,36,166,0.08)',
                padding: 2.5,
                justifyContent: 'space-between',
                textAlign: 'start',
                textDecoration: 'none',
                transition: 'all 0.2s',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 12px 28px rgba(81,36,166,0.12)',
                    borderColor: 'rgba(81,36,166,0.3)',
                },
            }}
        >
            <Stack spacing={1.5}>
                <Box sx={{ borderRadius: '10px', overflow: 'hidden', lineHeight: 0, aspectRatio: '16/9' }}>
                    <img
                        alt={post.title}
                        src={post.image}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        loading="lazy"
                    />
                </Box>
                {showDate && (
                    <Typography
                        component="time"
                        dateTime={post.date}
                        sx={{ fontSize: '0.78rem', color: FG_3, fontWeight: 500 }}
                    >
                        {new Date(post.date).toLocaleDateString(LANG_LOCALE[lang] ?? lang, {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        })}
                    </Typography>
                )}
                <Typography component={titleComponent} variant="bodyArticle" sx={{ color: INK, fontWeight: 700 }}>
                    {post.title}
                </Typography>
                <Typography component="p" variant="bodyArticle2" sx={{ color: FG_2 }}>
                    {post.description}
                </Typography>
            </Stack>
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.6,
                    fontSize: '0.85rem',
                    color: PURPLE,
                    fontWeight: 600,
                    mt: 1,
                }}
            >
                {t('blog.latest_articles.read_more')}
                <ArrowIcon size={15} />
            </Box>
        </Stack>
    );
}
